import React, { useState } from 'react';
import NationalityInput from './NationalityInput';

// ── Main component ───────────────────────────────────────────
function MatchSetup({ onComplete }) {
  const [form, setForm] = useState({
    athlete_blue_name:        '',
    athlete_red_name:         '',
    athlete_blue_nationality: '',
    athlete_red_nationality:  '',
    event_name:               '',
    event_date:               new Date().toISOString().split('T')[0],
    weight_category:          '',
    num_rounds:               3,
    round_duration:           120,
    video_source:             '',
  });
  const [loading, setLoading] = useState(false);

  const set = (field, value) => setForm(f => ({ ...f, [field]: value }));

  const handleStart = async () => {
    if (!form.athlete_blue_name.trim() || !form.athlete_red_name.trim()) {
      alert('Inserisci i nomi di entrambi gli atleti');
      return;
    }
    setLoading(true);
    await onComplete({
      ...form,
      num_rounds:     parseInt(form.num_rounds, 10),
      round_duration: parseInt(form.round_duration, 10),
    });
    setLoading(false);
  };

  const handleImport = () => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    input.onchange = (e) => {
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = async (ev) => {
        try {
          const jsonData = JSON.parse(ev.target.result);
          setLoading(true);
          await onComplete({ importedData: jsonData });
          setLoading(false);
        } catch { alert('File JSON non valido'); setLoading(false); }
      };
      reader.readAsText(file);
    };
    input.click();
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ maxWidth: 620 }}>
        <div className="modal-header">
          <div className="modal-title">TKD Video Analysis &mdash; Nuovo Incontro</div>
        </div>

        <div className="modal-body">

          {/* ── Atleti ── */}
          <div className="athletes-row">
            {/* BLU */}
            <div className="form-group">
              <label className="form-label" style={{ color: 'var(--color-blue-light)' }}>Atleta BLU</label>
              <input
                className="form-input blue-accent"
                placeholder="Nome atleta blu"
                value={form.athlete_blue_name}
                onChange={e => set('athlete_blue_name', e.target.value)}
              />
              <label className="form-label" style={{ marginTop: 6 }}>Nazionalità BLU</label>
              <NationalityInput
                value={form.athlete_blue_nationality}
                onChange={v => set('athlete_blue_nationality', v)}
                accentColor="var(--color-blue)"
              />
            </div>
            {/* ROSSO */}
            <div className="form-group">
              <label className="form-label" style={{ color: 'var(--color-red-light)' }}>Atleta ROSSO</label>
              <input
                className="form-input red-accent"
                placeholder="Nome atleta rosso"
                value={form.athlete_red_name}
                onChange={e => set('athlete_red_name', e.target.value)}
              />
              <label className="form-label" style={{ marginTop: 6 }}>Nazionalità ROSSO</label>
              <NationalityInput
                value={form.athlete_red_nationality}
                onChange={v => set('athlete_red_nationality', v)}
                accentColor="var(--color-red)"
              />
            </div>
          </div>

          {/* ── Evento ── */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Nome Evento</label>
              <input
                className="form-input"
                placeholder="Es. Campionato Italiano 2026"
                value={form.event_name}
                onChange={e => set('event_name', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">Data</label>
              <input
                className="form-input"
                type="date"
                value={form.event_date}
                onChange={e => set('event_date', e.target.value)}
              />
            </div>
          </div>

          {/* ── Categoria + Round ── */}
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Categoria Peso</label>
              <input
                className="form-input"
                placeholder="Es. -68kg"
                value={form.weight_category}
                onChange={e => set('weight_category', e.target.value)}
              />
            </div>
            <div className="form-group">
              <label className="form-label">N. Round</label>
              <input
                className="form-input"
                type="number"
                min={1} max={5}
                value={form.num_rounds}
                onChange={e => set('num_rounds', e.target.value)}
              />
            </div>
          </div>

          {/* ── Durata round ── */}
          <div className="form-group">
            <label className="form-label">Durata round (secondi)</label>
            <input
              className="form-input"
              type="number"
              min={30} max={600}
              value={form.round_duration}
              onChange={e => set('round_duration', e.target.value)}
            />
          </div>

          {/* ── Sorgente video ── */}
          <div className="form-group">
            <label className="form-label">Sorgente Video (URL YouTube / NAS &mdash; opzionale)</label>
            <input
              className="form-input"
              placeholder="https://www.youtube.com/watch?v=... oppure URL video NAS"
              value={form.video_source}
              onChange={e => set('video_source', e.target.value)}
            />
          </div>

        </div>

        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={handleImport} disabled={loading}>
            Carica sessione precedente
          </button>
          <button
            className="btn btn-success btn-lg"
            onClick={handleStart}
            disabled={loading || !form.athlete_blue_name.trim() || !form.athlete_red_name.trim()}
            style={{ minWidth: 160 }}
          >
            {loading ? 'Caricamento...' : 'Inizia Analisi'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MatchSetup;
